import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { usePepwiseAuthController } from 'Context/contexts/AuthContext';
import SilverDashboard from './pages/SilverDashboard';
import SilverHistory from './pages/SilverHistory';
import GoldDashboard from './pages/GoldDashboard';
import GoldReference from './pages/GoldReference';
import AssetTagging from './pages/AssetTagging';
import Iberia from './pages/Iberia';
import { DAI_BASE_PATH } from './constants';
import './DataAssetIntelligence.scss';

// Each screen's CSS came from a separate HTML document and reuses generic class
// names, so the stylesheet keys those rules off a per-page modifier.
const PAGE_CLASS: Array<[string, string]> = [
	['/silver/history', 'dai-page-silver-history'],
	['/gold/reference', 'dai-page-gold-reference'],
	['/gold', 'dai-page-gold'],
	['/iberia', 'dai-page-iberia'],
	['/asset-tagging', 'dai-page-asset-tagging']
];

const pageClassFor = (pathname: string): string => {
	const sub = pathname.slice(DAI_BASE_PATH.length);
	const match = PAGE_CLASS.find(([prefix]) => sub === prefix || sub.startsWith(`${prefix}/`));
	return match ? match[1] : 'dai-page-silver-dashboard';
};

/**
 * Data Assets Intelligence — replaces the iframed Flask dashboard.
 *
 * Mounted once at `${DAI_BASE_PATH}/*`; the six screens are nested routes so
 * the in-page tab bar keeps working as deep links.
 */
const DataAssetIntelligence: React.FC = () => {
	const [controller] = usePepwiseAuthController();
	const { capabilities } = controller;
	const location = useLocation();

	const isEntitled = (capabilities ?? []).includes('Data Ops');
	if (!isEntitled) {
		return <Navigate to="/LandingPage" replace />;
	}

	return (
		<div className={`dai-root ${pageClassFor(location.pathname)}`}>
			<Routes>
				<Route path="/" element={<SilverDashboard />} />
				<Route path="silver/history" element={<SilverHistory />} />
				<Route path="gold" element={<GoldDashboard />} />
				<Route path="gold/reference" element={<GoldReference />} />
				<Route path="iberia" element={<Iberia />} />
				<Route path="asset-tagging" element={<AssetTagging />} />
				<Route path="*" element={<Navigate to={DAI_BASE_PATH} replace />} />
			</Routes>
		</div>
	);
};

export default DataAssetIntelligence;
